import { ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-work-location-prompt',
  imports: [ReactiveFormsModule, InputTextModule],
  templateUrl: './work-location-prompt.html',
  styleUrl: './work-location-prompt.css'
})
export class WorkLocationPrompt {
  form!: FormGroup;
  isSaving = false;
  userId: number = 0;

  constructor(
    private fb: FormBuilder,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    const d = this.config.data || {};
    this.userId = d.userId || 0;

    this.form = this.fb.group({
      address1: [d.address1 || '', [Validators.maxLength(200)]],
      address2: [d.address2 || '', [Validators.maxLength(200)]],
      city:     [d.city     || '', [Validators.required, Validators.maxLength(100)]],
      state:    [d.state    || '', [Validators.required, Validators.maxLength(100)]],
      zip:      [d.zip      || '', [Validators.maxLength(20)]],
      country:  [d.country  || '', [Validators.maxLength(100)]]
    });
  }

  cancel(): void {
    this.ref.close();
  }

  save(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.isSaving = true;
    const payload = {
      address1: this.form.value.address1 || null,
      address2: this.form.value.address2 || null,
      city:     this.form.value.city,
      state:    this.form.value.state,
      zip:      this.form.value.zip     || null,
      country:  this.form.value.country || null
    };
    this.userService.updateAddress(this.userId, payload).subscribe({
      next: () => this.ref.close({ success: true }),
      error: () => {
        this.isSaving = false;
        this.cdr.markForCheck();
      }
    });
  }

  get f() { return this.form.controls; }
}
